import { madeRequest } from '../../helpers/api'
import { replaceRouteParams } from '../../helpers/url'

import { ENDPOINT_PLATFORM, ENDPOINTS } from '../../constants/api'
import { FACEBOOK_BUSINESS_MANAGER_ID } from '../../pages/Settings/RightHolderProfile/fields'

// PLOP_APPEND_PATTERN_ANCHOR

export function getChoicesGeolocationsService(params) {
  return madeRequest('GET', {
    url: ENDPOINTS.choicesGeolocations,
    params
  })
}

export function getChoicesCountriesService() {
  return madeRequest('GET', {
    params: {
      limit: 9999
    },
    url: ENDPOINTS.choicesCountries
  })
}

export function getChoicesInterestsService(params) {
  return madeRequest('GET', {
    url: ENDPOINTS.choicesInterests,
    params
  })
}

export function getChoicesLanguagesService(params) {
  return madeRequest('GET', {
    url: ENDPOINTS.choicesFacebookLanguages,
    params
  })
}

export function getChoicesPixelsService(params, platform) {
  return madeRequest('GET', {
    url: replaceRouteParams(ENDPOINTS.choicesPixels, { platform: ENDPOINT_PLATFORM[platform] }),
    params
  })
}

export function getChoicesCTAService(params) {
  return madeRequest('GET', {
    url: ENDPOINTS.choicesCTA,
    params
  })
}

export function getChoicesActionsService(params) {
  return madeRequest('GET', {
    url: ENDPOINTS.choicesActions,
    params
  })
}

export function getChoicesAllocationUnitsService(params) {
  return madeRequest('GET', {
    url: ENDPOINTS.allocationUnits,
    params
  })
}

export function getFacebookClientAppsService(params) {
  return madeRequest('GET', {
    params,
    url: replaceRouteParams(ENDPOINTS.facebookClientApps, { 'bussines-id': params[FACEBOOK_BUSINESS_MANAGER_ID] })
  })
}

export function getChoicesBehavioursService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.choicesBehaviours
  })
}

export function getCustomConversionsService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.customConversions
  })
}
